import React, { useState } from "react";

import PropTypes from "prop-types";
import {Modal, ModalBody, Carousel, CarouselItem, CarouselControl} from "reactstrap";
import BasicProviderImage from "../../components/providerimage/BasicProviderImage";
import moment from "moment";

const paddingBottomStyle = {
  paddingBottom: "34px"
}

const MediaModal = (props) => {
  const { images, provider, location, reviewDate, toggle, isOpen, startIndex } = props;
  const [activeIndex, setActiveIndex] = useState(startIndex ? startIndex : 0);
  const [animating, setAnimating] = useState(false);

  const buildPrettyAddress = (addressObj) => `${addressObj.street}, ${addressObj.city}, ${addressObj.state}`;
  const businessName = location ? location.businessName : "";
  const businessAddress = location ? buildPrettyAddress(location.businessAddress) : "";

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === props.images.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0 ? props.images.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const hideLeftArrow = () => {
    return activeIndex === 0 || props.images.length === 0;
  };
  const hideRightArrow = () => {
    return activeIndex === props.images.length - 1 || props.images.length === 0;
  };


  const slides = images.map((image, idx) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={idx}
        timeout={250} //Corresponds to override value in _carousel.scss
        className="cursor-default"
      >
        <img src={image} className="img-responsive img-contain rounded" alt={`review-image-${idx}`}/>
      </CarouselItem>
    );
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <div className="d-flex flex-row pt-3 px-3 pb-0">
        <div className="d-flex align-items-center">
          <BasicProviderImage provider={provider} customProviders={provider} />
        </div>
        <div className="truncate inline-block zoom-image-business-info d-flex flex-column justify-content-center text-center">
          <span className="btn-link cursor-pointer name inline-block truncate font-weight-bold clickable">
            {businessName}
          </span>
          <div className="media-address inline-block truncate">
            {businessAddress}
          </div>
        </div>
        <div className="d-flex align-items-center text-right">
          {moment(reviewDate).format("MM/D/YYYY")}
        </div>
      </div>
      <ModalBody className="px-0" style={paddingBottomStyle}>
        <div className="d-flex flex-row justify-content-between">
          <Carousel
            className="flex-grow-1 cursor-default"
            activeIndex={activeIndex}
            next={next}
            previous={previous}
            interval={false}
          >
            {slides}
            <CarouselControl className={hideLeftArrow() ? "invisible cursor-pointer-override" : undefined} direction="prev" directionText="Previous" onClickHandler={previous} />
            <CarouselControl className={hideRightArrow() ? "invisible cursor-pointer-override" : undefined} direction="next" directionText="Next" onClickHandler={next} />
          </Carousel>
        </div>
      </ModalBody>
    </Modal>
  );
};

MediaModal.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  provider: PropTypes.string.isRequired,
  location: PropTypes.object,
  reviewDate: PropTypes.object.isRequired,
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  startIndex: PropTypes.number
};

export default MediaModal;
